import { Model } from './model';
import { Paginated } from './paginated';
import { Role } from './role';

export class Profile extends Model {
  userName: string;
  name: string;
  surname: string;
  email: string;
  registrationEmail: string;
  phone?: string;
  mobilePhone: string;
  idUserProfile?: number;
  role?: Role;
  status?: Role;
  resetPassword?: boolean;

  // afterDeserialize(input: any) {
  // }
}

export class Profiles extends Paginated {
  data: Array<Profile>;
}

export class ProfileForm {
  userName: string = '';
  name: string = '';
  surname: string = '';
  email: string = '';
  registrationEmail: string = '';
  phone: string = '';
}
